var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotaRegCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 10.1208C30.6287 9.39217 28.1102 9 25.5 9C11.4167 9 0 20.4167 0 34.5C0 48.5833 11.4167 60 25.5 60C30.312 60 34.8126 58.6672 38.6529 56.3505L25.5161 43.2674L19.6066 49.175L13.7332 43.2306L19.6027 37.3781L19.545 37.3207L25.4026 31.5125L25.444 31.5537L31.3389 25.6758L37.235 31.5524L31.3499 37.4355L44.9553 50.9853C48.7258 46.54 51 40.7856 51 34.5C51 31.8898 50.6078 29.3713 49.8792 27H37.9524C35.2173 27 33 24.7827 33 22.0476V10.1208Z",
    fill: "#F1A43A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0C37.7909 0 36 1.79086 36 4V20C36 22.2091 37.7909 24 40 24H56C58.2091 24 60 22.2091 60 20V4C60 1.79086 58.2091 0 56 0H40ZM48.0001 4.99998C49.1047 4.99998 50.0001 5.89541 50.0001 6.99998V9.99998H53.0001C54.1047 9.99998 55.0001 10.8954 55.0001 12C55.0001 13.1045 54.1047 14 53.0001 14H50.0001V17C50.0001 18.1045 49.1047 19 48.0001 19C46.8955 19 46.0001 18.1045 46.0001 17V14H43.0001C41.8955 14 41.0001 13.1045 41.0001 12C41.0001 10.8954 41.8955 9.99998 43.0001 9.99998H46.0001V6.99998C46.0001 5.89541 46.8955 4.99998 48.0001 4.99998Z",
    fill: "#F1A43A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotaRegCell);
export default __webpack_public_path__ + "static/media/cota_reg_cell.2668fc6f9cbe8bb34ed424e4a9cee3a0.svg";
export { ForwardRef as ReactComponent };